import React, { useState,useEffect, useContext } from 'react'
import Comment from '../../Reuable/Comment/Comment'
import { useParams } from 'react-router-dom'
import { db } from '../../Firebase/firebase'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'
import './SinglePostComments.css'

const SinglePostComments = () => {
  const { isLight } = useContext(ThemeContext)
  const { postID } = useParams()
  const [comments, setComments] = useState([])
  
  useEffect(() => {
    db.collection('posts').doc(postID).collection('comments').orderBy('createdAt', 'desc').onSnapshot(snapshot => {
      setComments(snapshot.docs)
    })
      
  }, [])
  
  return (
    <section className={`single-post-comments ${isLight ? "" : "dark"}`}>
      <div className="single-post-comments__header">
          <h1>Comments</h1>
      </div>
      {
        comments.map((comment)=> {
          return(
            <Comment key={comment.id} commentID={comment.id} props={comment.data()} />
          )
        })
      }
    </section>
  )
}

export default SinglePostComments
